<script>
import config from "@/helpers/config"
import niceFunctions from "@/helpers/niceFunctions"
export default {
  data() {
    return {  
    }
  }, 
  props:['windowScroll'],
  computed: {
    url() { return config.urlToServer }, 
    publicPageColors() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageColors : null },
    publicPage() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPage : {} },
    tabs() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.tabs : [] },
    availableBookings() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.availableBookings : [] },
    availableCourses() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.availableCourses : [] },
    customerName() { return this.$store.state.publicPage != null ? this.$store.state.publicPage.customerName : '' },
    settings() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.settings : null },
    hasSettings() { return this.settings },
    publicPageImages() { return this.$store.state.publicPage != null ?  this.$store.state.publicPage.publicPageImages : null },
    publicPageLogo() { return this.publicPageImages != null ?  this.publicPageImages.find(x => x.location == 'logo') : null },
    selectedPage() {
      var page = '';
      if(this.$route.name != undefined)
      {
        return this.$route.name.includes('_') ? this.$route.name.split('_')[1] : this.$route.name;
      }
      return this.$route.name 
    }
  },
  watch:
  {
    customerName(newvalue)
    {
      document.title = newvalue
    }
  },
  methods:
  {
    getColor(location)
    {
      return niceFunctions.getColor(this.publicPageColors, location)
    },
    getPageName(page) {
      return niceFunctions.getPageName(page)
    }
  }
}
</script>
<template>
  <section class="Menu" v-if="publicPageImages != null" v-fade-in>
    <div class="Menu-logo" v-if="publicPageLogo">
      <img :src="url + 'uploads/' + publicPageLogo.customer_id + '/images/' + publicPageLogo.image_name" style="height: 100%" />
    </div>
    <div class="p" :class="[windowScroll > 200 ? 'Menu-addedWhite' : 'Menu-noBg']">
      
        <router-link class="no-link-style"  :to="{ name: getPageName('home'), params: { id: $route.params.id } }"
          :style="{ 'background-color': selectedPage == 'home' ? getColor('background_color') : '' }">
          Hem
        </router-link>

        <router-link class="no-link-style"  :to="{ name: getPageName('community'), params: { id: $route.params.id } }"
          :style="{ 'background-color': selectedPage == 'community' ? getColor('background_color') : '' }">
          {{ hasSettings ? settings.Community.singular : '' }}
        </router-link>

        <router-link v-for="tab in tabs" :key="tab.id" class="no-link-style" 
          :to="{ name: getPageName('tab'), params: { id: $route.params.id, tabid: tab.id } }"
          :style="{ 'background-color': selectedPage == 'tab' && $route.params.tabid == tab.id ? getColor('background_color') : '' }">
          {{ tab.name }}
        </router-link>

        <router-link v-if="publicPage.include_image_gallery" class="no-link-style"
          :to="{ name: getPageName('imageGallery'), params: { id: $route.params.id } }"
          :style="{ 'background-color': selectedPage == 'imageGallery' ? getColor('background_color') : '' }">
          {{ hasSettings ? settings.ImageGallery.singular : '' }}
        </router-link>

        <span v-if="availableBookings.length == 1"
          :style="{ 'background-color': selectedPage == 'bookingHoursAdd' || selectedPage == 'bookingDaysAdd' ? getColor('background_color') : '' }">
          <router-link v-if="availableBookings[0].duration_unit == 'Timmar'" class="no-link-style" 
            :to="{ name: getPageName('bookingHoursAdd'), params: { id: $route.params.id, bookingid: availableBookings[0].id } }">
            {{ availableBookings[0].name }}
          </router-link>
          <router-link v-if="availableBookings[0].duration_unit == 'Dagar'" class="no-link-style"
            :to="{ name: getPageName('bookingDaysAdd'), params: { id: $route.params.id, bookingid: availableBookings[0].id } }">
            {{ availableBookings[0].name }}
          </router-link>
        </span>

        <router-link v-if="availableBookings.length > 1" class="no-link-style"
          :to="{ name: getPageName('bookings'), params: { id: $route.params.id } }"
          :style="{ 'background-color': selectedPage == 'bookings' ? getColor('background_color') : '' }">
          {{ hasSettings ? settings.BookingItem.plural : '' }}
        </router-link>

  
          <router-link class="no-link-style" v-if="availableCourses.length == 1"
            :to="{ name: getPageName('courseDetails'), params: { id: $route.params.id, courseid: availableCourses[0].id } }" :style="{ 'background-color': selectedPage == 'courseDetails' ? getColor('background_color') : '' }">
            {{ availableCourses[0].name }}
          </router-link>
      

        <router-link v-if="availableCourses.length > 1" class="no-link-style" 
          :to="{ name: getPageName('courses'), params: { id: $route.params.id } }"
          :style="{ 'background-color': selectedPage == 'courses' || selectedPage == 'courseDetails' ? getColor('background_color') : '' }">
          {{ hasSettings ? settings.Course.plural : '' }}
        </router-link>

       
          <router-link v-if="availableCourses.length > 0"
          :style="{ 'background-color': selectedPage == 'instructors' ? getColor('background_color') : '' }" class="no-link-style"
            :to="{ name: getPageName('instructors'), params: { id: $route.params.id } }">
            {{ hasSettings ? settings.CourseInstructor.plural : '' }}
          </router-link>
       

        <router-link v-if="publicPage.include_contact" class="no-link-style"
          :to="{ name: getPageName('contact'), params: { id: $route.params.id } }"
          :style="{ 'background-color': selectedPage == 'contact' ? getColor('background_color') : '' }">
          Kontakta Oss
        </router-link>
      
    </div>
  </section>
</template>

<style scoped>
.Menu
{
  width:100%; 
  height: 120px; 
  color: white;
  position: fixed;
  top:0px;
  z-index: 20; 
  font-family: 'Raleway', sans-serif;
  text-transform: capitalize;
  text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000;
}

.p {
  display:flex;
  justify-content: center;

}
.Menu-addedWhite
{
  background: rgba(255,255,255,0.97);
  border-bottom: 1px solid #ccc;
  transition: 0.3s;
}
.Menu-noBg
{
  background: none;
  transition: 0.3s;
}

.Menu-logo {
  height: 4.9vw; position: absolute; top: 5px; left: 5px;
}

.no-link-style {
  all: unset;
  display: inline-block;
  padding: 2vw 2vw;
  text-align: center;
  font-size: 1.2vw;
  font-weight: bold;
  cursor: pointer;
  color: inherit;
  text-shadow: inherit;
}

@media (-webkit-device-pixel-ratio: 1.25) {
  .no-link-style {
    /* padding: 20px 25px; */
    /* font-size: 11pt; */
    /* vertical-align: center; */
  }

  .Menu-logo {
    /* height: 52px; */
  }
} 


@media only screen and (min-width: 1600px) {
  .no-link-style {
    font-size: 14pt;
    /* padding: 26px 30px; */
  }
}
</style>
